import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["prefix", "suffix", "editMode", "value", "InputProps", "InputLabelProps", "variant"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context3, _context4; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context3 = ownKeys(Object(t), !0)).call(_context3, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context4 = ownKeys(Object(t))).call(_context4, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { makeStyles, InputAdornment, TextField as MuiTextField, Typography, RaiseColors } from "components/mui";
import React from "react";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function TextField(_ref) {
  var _InputLabelProps$shri, _context, _context2;
  var _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? "" : _ref$prefix,
    _ref$suffix = _ref.suffix,
    suffix = _ref$suffix === void 0 ? "" : _ref$suffix,
    _ref$editMode = _ref.editMode,
    editMode = _ref$editMode === void 0 ? true : _ref$editMode,
    value = _ref.value,
    _ref$InputProps = _ref.InputProps,
    InputProps = _ref$InputProps === void 0 ? {} : _ref$InputProps,
    _ref$InputLabelProps = _ref.InputLabelProps,
    InputLabelProps = _ref$InputLabelProps === void 0 ? {} : _ref$InputLabelProps,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "outlined" : _ref$variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var useStyles = makeStyles(function () {
    return {
      inputRoot: {
        whiteSpace: "pre-wrap",
        borderRadius: 8,
        padding: props.multiline ? "0px" : "inherit",
        "& .MuiOutlinedInput-notchedOutline": {
          border: "1px solid ".concat(RaiseColors.grayscale200)
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
          border: "1px solid ".concat(RaiseColors.bahama1200)
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          border: "1px solid ".concat(RaiseColors.grayscale900)
        },
        // Override Chrome's default autofill styling which applies a blue/yellow background highlight.
        // The large inset box shadow technique replaces the autofill background with our design system color,
        // and the long transition duration prevents Chrome from reverting the background color change.
        "& input:-webkit-autofill": {
          WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset"),
          WebkitTextFillColor: RaiseColors.midnight,
          transition: "background-color 5000s ease-in-out 0s"
        },
        "& input:-webkit-autofill:hover": {
          WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset")
        },
        "& input:-webkit-autofill:focus": {
          WebkitBoxShadow: "0 0 0 1000px ".concat(RaiseColors.neutral100, " inset")
        }
      },
      input: {
        padding: "12px 16px",
        fontSize: 14
      }
    };
  });
  var classes = useStyles();
  InputProps.classes = _objectSpread({
    root: classes.inputRoot,
    input: classes.input
  }, InputProps.classes);
  InputLabelProps.shrink = (_InputLabelProps$shri = InputLabelProps.shrink) !== null && _InputLabelProps$shri !== void 0 ? _InputLabelProps$shri : true;
  if (prefix) {
    InputProps.startAdornment = /*#__PURE__*/_jsx(InputAdornment, {
      position: "start",
      children: prefix
    });
  }
  if (suffix) {
    InputProps.endAdornment = /*#__PURE__*/_jsx(InputAdornment, {
      position: "end",
      children: suffix
    });
  }
  if (editMode) {
    return /*#__PURE__*/_jsx(MuiTextField, _objectSpread(_objectSpread({}, props), {}, {
      style: {
        paddingLeft: "0px"
      },
      InputProps: InputProps,
      InputLabelProps: InputLabelProps,
      value: value || "" // "" to stop uncontrolled input errors from React
      ,
      variant: variant,
      FormHelperTextProps: {
        sx: {
          margin: "8px 0px 0px 0px"
        }
      }
    }));
  }
  if (props.multiline && value) {
    var splitTextArray = value.split("\n");
    return /*#__PURE__*/_jsx(Typography, {
      color: RaiseColors.gray300,
      children: value
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: value ? _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(prefix || "")).call(_context2, value)).call(_context, suffix || "") : null
  });
}
export default TextField;